import { computed, ref, getCurrentInstance } from 'vue';
import * as vuetifyInstance from '@/plugins/vuetify';

export default function useVuetify() {
    const vuetify = ref(vuetifyInstance);
    const proxy = getCurrentInstance();

    const breakpoint = computed(() => vuetify.value.default.framework.breakpoint);

    const $snackbar = (text, type = null, options = {}) => {
        proxy.proxy.$snackbar(text, type, options);
    };

    return {
        vuetify,
        breakpoint,
        $snackbar,
    };
}
